// ============================================================
// STEP 1: Replace these values from your Azure App Registration
// Azure Portal → Entra ID → App Registrations → Your App
// ============================================================

export const msalConfig = {
  auth: {
    clientId: "8d1440d2-b903-45a4-947d-85fe318ffa07",           // Application (client) ID
    authority: "https://login.microsoftonline.com/487bbdd1-c31a-4ca3-966d-23cfd572387f", // Directory (tenant) ID
    redirectUri: window.location.origin,   // Must match Azure App Registration redirect URI
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// ============================================================
// STEP 2: Define admin users by their Azure email addresses
// These users will see ALL subcontractor entries
// Everyone else will only see their own entries
// ============================================================

export const ADMIN_EMAILS = [
  "samirkabiraj@techsoft-inc.com",      // CEO - replace with your actual email
  "paromita.chakraborty@techsoft-inc.com",      // HR 
  "sam@techsoft-inc.com",        // Mnager
];

// ============================================================
// STEP 3: Define project codes for your contracts
// ============================================================

export const DEFAULT_PROJECT_CODES = [
  "VA-PROJ-001",
  "VA-PROJ-002",
  "VA-PROJ-003",
  "FORCECOM-001",
  "FORCECOM-002",
  "ADMIN",
  "OVERHEAD",
];
